module.exports = __webpack_public_path__ + "static/pdp2-ef8267174f295b048d59c7d15295833b.png";